// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","content":"Hero_content__YK9OZ"};